import { FloatingPanelGroup } from "@babackapp/ui/components/floating-panel";
import { ContextualTipsPanel } from "@babackapp/ui/components/contextual-tips";
import { useTranslation } from "react-i18next";
import { CirclePlus, Columns3Cog } from "lucide-react";
import { useWorkflowForm } from "../context/workflows-editor-workflows-context";


export type TipsPanelProps = {
  removeIfHidden?: boolean;
}


export function TipsPanel({ removeIfHidden }: TipsPanelProps) {
  const { t } = useTranslation("trackoffice");
  const { watch } = useWorkflowForm();
  const workflowDefinition = watch("workflow.definition");

  const defaultTips = [
    {
      id: "customize-workflow-node",
      title: t(
        "workflowsEditor.tips.selectTemplate.title",
        "Customize the template",
      ),
      description: t(
        "workflowsEditor.tips.selectTemplate.desc",
        "Click on the customize button in the email action node to open the template editor.",
      ),
      Icon: Columns3Cog,
    },
  ];

  if (!workflowDefinition?.nodes?.length) {
    defaultTips.splice(0, 0, {
      id: "link-workflow-node",
      title: t(
        "workflowsEditor.tips.addEmail.title",
        "Link a node",
      ),
      description: t(
        "workflowsEditor.tips.addEmail.desc",
        "Link nodes together by clicking the \"+\" button on any node.",
      ),
      Icon: CirclePlus,
    });
  }


  return (
    <div className="z-[50] pointer-events-none">
      <FloatingPanelGroup className="pointer-events-auto">
        <ContextualTipsPanel
          removeIfHidden={removeIfHidden}
          title={t("workflowsEditor.tips.title", "Tips")}
          defaultTips={defaultTips}
        />
      </FloatingPanelGroup>
    </div>
  );
}
